import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout, SignOutLayout } from "./layouts";

// Route containers
import Starter from "./containers/pages/Auth/starter";
import signUp from "./containers/pages/Auth/signUp";
import signIn from "./containers/pages/Auth/signIn";
import Welcome from "./containers/pages/Auth/welcome";
import ServiceAgree from "./containers/pages/Auth/serviceAgree";
import PrivateAgree from "./containers/pages/Auth/privateAgree";

import cafe from "./containers/pages/Auth/cafe";
import cafeInAppOrderReturnUrl from "./containers/pages/Auth/cafeInAppOrderReturnUrl";
import cafeMsgOrderReturnUrl from "./containers/pages/Auth/cafeMsgOrderReturnUrl";

import Dashboard from "./containers/pages/Dashboard/dashboard";

import ReviewList from "./containers/pages/Review/reviewList";
import ReviewMileage from "./containers/pages/Review/reviewMileage";
import ReviewWrite from "./containers/pages/Review/reviewWrite";
import ReviewMassWrite from "./containers/pages/Review/reviewMassWrite";

import ReplyByProductList from "./containers/pages/Review/replyByProductList";
import ReviewGroup from "./containers/pages/Review/reviewGroup";


import ReplyWriteConfig from "./containers/pages/Review/replyWriteConfig";
import ReviewWriteConfig from "./containers/pages/Review/reviewWriteConfig";
import MileageConfig from "./containers/pages/Review/mileageConfig";
import ReviewFilter from "./containers/pages/Review/reviewFilter";

import WidgetList from "./containers/pages/Widget/widgetList";
import MetaWidget from "./containers/pages/Widget/metaWidget";
import Labeling from "./containers/pages/Widget/labeling";
import productWidgetList from "./containers/pages/Widget/productWidgetList";
import TotalAiWidget from "./containers/pages/Widget/totalAiWidget";

import KakaoMsgSetting from "./containers/pages/ReviewBooster/kakaoMsgSetting";
import MsgList from "./containers/pages/ReviewBooster/msgList";

import Banner from "./containers/pages/Design/banner";
import DesignAddOn from "./containers/pages/Design/designAddOn";
import DesignSetting from "./containers/pages/Design/designSetting";

import GoodsList from "./containers/pages/goods/goodsList";

import TeamUserInfoEdit from "./containers/pages/Store/teamUserInfoEdit";
import CompanyInfoEdit from "./containers/pages/Store/companyInfoEdit";
import InAppOrder from "./containers/pages/Store/inAppOrder";
import OrderEnd from "./containers/pages/Store/orderEnd";
import InAppOrderList from "./containers/pages/Store/inAppOrderList";
import MsgOrder from "./containers/pages/Store/msgOrder";
import MsgOrderList from "./containers/pages/Store/msgOrderList";


import StoreList from "./containers/pages/SuperAdmin/storeList";
import StoreFnList from "./containers/pages/SuperAdmin/storeFnList";

// Route Views
import Errors from "./views/Errors";




// src/stores/Common.js의 name값 참고
export default [
  {
    path: "/",
    exact: true,
    layout: SignOutLayout,
    component: Starter
  },
  {
    path: "/cafe24",
    layout: SignOutLayout,
    component: cafe
  },
  {
    path: "/cafeRedirect",
    layout: SignOutLayout,
    component: cafe
  },
  {
    path: "/cafeInAppOrderReturnUrl",
    layout: SignOutLayout,
    component: cafeInAppOrderReturnUrl
  },
  {
    path: "/cafeMsgOrderReturnUrl",
    layout: SignOutLayout,
    component: cafeMsgOrderReturnUrl
  },
  {
    path: "/signUp",
    layout: SignOutLayout,
    component: signUp
  },
  {
    path: "/signIn",
    layout: SignOutLayout,
    component: signIn
  },
  {
    path: "/welcome",
    layout: SignOutLayout,
    component: Welcome
  },
  {
    path: "/serviceAgree",
    layout: SignOutLayout,
    component: ServiceAgree
  },
  {
    path: "/privateAgree",
    layout: SignOutLayout,
    component: PrivateAgree
  },
  {
    path: "/dashboard",
    layout: DefaultLayout,
    info: {mainMenu: 'dashboard'},
    component: Dashboard
  },
  //리뷰
  {
    path: "/reviewList",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewList'},
    component: ReviewList
  },
  {
    path: "/reviewMileage",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewMileage'},
    component: ReviewMileage
  },
  {
    path: "/reviewWrite",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewWrite'},
    component: ReviewWrite
  },
  {
    path: "/reviewMassWrite",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewMassWrite'},
    component: ReviewMassWrite
  },
  //리뷰작성유도
  {
    path: "/kakaoMsgSetting",
    layout: DefaultLayout,
    info: {mainMenu: 'booster', subMenu: 'kakaoMsgSetting'},
    component: KakaoMsgSetting
  },
  {
    path: "/msgList",
    layout: DefaultLayout,
    info: {mainMenu: 'booster', subMenu: 'msgList'},
    component: MsgList
  },
  //설정
  {
    path: "/reviewWriteConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'reviewWriteConfig'},
    component: ReviewWriteConfig
  },

  {
    path: "/mileageConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'mileageConfig'},
    component: MileageConfig
  },
  {
    path: "/reviewGroup",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'reviewGroup'},
    component: ReviewGroup
  },
  {
    path: "/reviewFilter",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'reviewFilter'},
    component: ReviewFilter
  },

  {
    path: "/replyWriteConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'replyWriteConfig'},
    component: ReplyWriteConfig
  },
  {
    path: "/replyByProductList",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'replyByProductList'},
    component: ReplyByProductList
  },
  //위젯 Labeling
  {
    path: "/widgetList",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'widgetList'},
    component: WidgetList
  },
  {
    path: "/metaWidget",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'metaWidget'},
    component: MetaWidget
  },
  {
    path: "/labeling",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'labeling'},
    component: Labeling
  },
  {
    path: "/productWidgetList",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'productWidgetList'},
    component: productWidgetList
  },
  {
    path: "/totalAiWidget",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'totalAiWidget'},
    component: TotalAiWidget
  },

  //디자인
  {
    path: "/designAddOn",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'designAddOn'},
    component: DesignAddOn
  },
  {
    path: "/designSetting",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'designSetting'},
    component: DesignSetting
  },
  {
    path: "/banner",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'banner'},
    component: Banner
  },
  //상품
  {
    path: "/goodsList",
    layout: DefaultLayout,
    info: {mainMenu: 'goods'},
    component: GoodsList
  },



  //리뷰 작성 설정

  //관리자
  {
    path: "/teamUserInfo",
    layout: DefaultLayout,
    info: {mainMenu: 'store', subMenu: 'teamUserInfo'},
    component: TeamUserInfoEdit
  },
  {
    path: "/companyInfo",
    layout: DefaultLayout,
    info: {mainMenu: 'store', subMenu: 'reviewList'},
    component: CompanyInfoEdit
  },
  //주문
  {
    path: "/inAppOrder",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'inAppOrder'},
    component: InAppOrder
  },
  {
    path: "/orderEnd",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'inAppOrder'},
    component: OrderEnd
  },
  {
    path: "/inAppOrderList",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'inAppOrderList'},
    component: InAppOrderList
  },
  {
    path: "/msgOrder",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'msgOrder'},
    component: MsgOrder
  },
  {
    path: "/msgOrderList",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'msgOrderList'},
    component: MsgOrderList
  },




  // 슈퍼관리자 메뉴
  {
    path: "/storeList",
    layout: DefaultLayout,
    info: {mainMenu: 'storeList', subMenu: 'storeList'},
    component: StoreList
  },
  {
    path: "/storeFnList",
    layout: DefaultLayout,
    info: {mainMenu: 'storeList', subMenu: 'storeFnList'},
    component: StoreFnList
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
];
